import { render } from "./RolesInput.vue?vue&type=template&id=4f1cd11c"
import script from "./RolesInput.vue?vue&type=script&lang=js"
export * from "./RolesInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/app/app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__